import { Component } from "react";
import { Button, ButtonGroup, FormControl } from "react-bootstrap";

interface VasLeaseTrackingProps {
	toggleSelections: Function;
	appendParams: Function;
	hasActiveLease: boolean;
	hasLeaseRecords: boolean;
	isChrome: boolean;
	searchParams: any;
}

class VasLeaseTracking extends Component<VasLeaseTrackingProps> {
	render() {
		return (
			<div className="VasLeaseTracking">
				<ButtonGroup>
					<div id="vas-lease-tracking-btn-left">
						{!this.props.hasActiveLease && (
							<Button
								onClick={() =>
									this.props.toggleSelections([
										"HasActiveLease-t",
										"HasLeaseRecords-f",
									])
								}
								tabIndex={-1}
							>
								<div id="vas-inspections-maintenance-btn-content-wrapper">
									{this.props.isChrome && (
										<input
											id="fleet-chrome-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											onChange={() =>
												this.props.toggleSelections([
													"HasActiveLease-t",
													"HasLeaseRecords-f",
												])
											}
										/>
									)}
									{!this.props.isChrome && (
										<input
											id="fleet-fox-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											onChange={() =>
												this.props.toggleSelections([
													"HasActiveLease-t",
													"HasLeaseRecords-f",
												])
											}
										/>
									)}
									<p>Has Active Lease</p>
								</div>
							</Button>
						)}
						{this.props.hasActiveLease && (
							<Button
								id="vas-ranges-checked"
								onClick={() =>
									this.props.toggleSelections([
										"HasActiveLease-f",
										"HasLeaseRecords-f",
									])
								}
								tabIndex={-1}
							>
								<div id="vas-inspections-maintenance-btn-content-wrapper">
									{this.props.isChrome && (
										<input
											id="fleet-chrome-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											defaultChecked
											onChange={() =>
												this.props.toggleSelections([
													"HasActiveLease-f",
													"HasLeaseRecords-f",
												])
											}
										/>
									)}
									{!this.props.isChrome && (
										<input
											id="fleet-fox-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											defaultChecked
											onChange={() =>
												this.props.toggleSelections([
													"HasActiveLease-f",
													"HasLeaseRecords-f",
												])
											}
										/>
									)}
									<p>Has Active Lease</p>
								</div>
							</Button>
						)}
					</div>
					<div id="vas-lease-tracking-btn-right">
						{!this.props.hasLeaseRecords && (
							<Button
								onClick={() =>
									this.props.toggleSelections([
										"HasLeaseRecords-t",
										"HasActiveLease-f",
									])
								}
								tabIndex={-1}
							>
								<div id="vas-inspections-maintenance-btn-content-wrapper">
									{this.props.isChrome && (
										<input
											id="fleet-chrome-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											onChange={() =>
												this.props.toggleSelections([
													"HasLeaseRecords-t",
													"HasActiveLease-f",
												])
											}
										/>
									)}
									{!this.props.isChrome && (
										<input
											id="fleet-fox-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											onChange={() =>
												this.props.toggleSelections([
													"HasLeaseRecords-t",
													"HasActiveLease-f",
												])
											}
										/>
									)}
									<p>Has Lease Records</p>
								</div>
							</Button>
						)}
						{this.props.hasLeaseRecords && (
							<Button
								id="vas-ranges-checked"
								onClick={() =>
									this.props.toggleSelections([
										"HasLeaseRecords-f",
										"HasActiveLease-f",
									])
								}
								tabIndex={-1}
							>
								<div id="vas-inspections-maintenance-btn-content-wrapper">
									{this.props.isChrome && (
										<input
											id="fleet-chrome-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											defaultChecked
											onChange={() =>
												this.props.toggleSelections([
													"HasLeaseRecords-f",
													"HasActiveLease-f",
												])
											}
										/>
									)}
									{!this.props.isChrome && (
										<input
											id="fleet-fox-radio"
											type="radio"
											name="leaseFilter"
											tabIndex={-1}
											defaultChecked
											onChange={() =>
												this.props.toggleSelections([
													"HasLeaseRecords-f",
													"HasActiveLease-f",
												])
											}
										/>
									)}
									<p>Has Lease Records</p>
								</div>
							</Button>
						)}
					</div>
				</ButtonGroup>
				<div className="VAS-LT-Unit-Number-Wrapper">
					<div className="VAS-LT-Unit-Number-Input-Wrapper">
						<FormControl
							placeholder="Unit Number"
							onChange={(e) =>
								this.props.appendParams([{ UnitNumber: e.target.value }])
							}
							value={this.props.searchParams.UnitNumber || ""}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default VasLeaseTracking;
